import { SET_PRODUCTS_SEARCH_VALUE } from '../types';

const initialState = {
  productsSearchValue: undefined,
  isBarCodeScan: false,
};

const productsSearchValue = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCTS_SEARCH_VALUE:
      return {
        ...state,
        productsSearchValue: action.productsSearchValue,
        isBarCodeScan: action.isBarCodeScan,
      };
    default:
      return state;
  }
};

export default productsSearchValue;
